import axios from 'axios';
import React, { useState } from 'react'
import { toast } from 'react-toastify';

const InvoiceCreate = () => {

  const [formData, setFormData] = useState({
    customer_name: '',
    sender_address: '',
    sender_number: '',
    invoice_id: '',
    issue_date: '',
    due_date: '',
    amount: '',
    status: 'Paid',
    buyer_from: '',
    buyer_address: '',
    buyer_number: '',
    buyer_email: '',
    issuer_from: '',
    issuer_address: '',
    issuer_number: '',
    issuer_email: '',
    sub_total: '',
    discount: '',
    estimated_tax: '',
    grand_total: '',
  });

  const handleChange = (e) => {
  const { id, value } = e.target;
  setFormData({ ...formData, [id]: value });
};

const [products, setProducts] = useState([
    {
      product_name: "",
      product_size: "",
      product_qty: 1,
      product_price: "",
      product_tax: "",
      total: "",
    },
  ]);

  // handle input change for dynamic rows
  const handleChangerow = (index, e) => {
    const { id, value } = e.target;
    const updatedProducts = [...products];
    updatedProducts[index][id] = value;
    setProducts(updatedProducts);
  };

  // add new empty product row
  const handleAddRow = () => {
    setProducts([
      ...products,
      {
        product_name: "",
        product_size: "",
        product_qty: 1,
        product_price: "",
        product_tax: "",
        total: "",
      },
    ]);
  };

  // clear (delete) product row
  const handleClearRow = (index) => {
    const updatedProducts = [...products];
    updatedProducts.splice(index, 1);
    setProducts(updatedProducts);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    ...formData,
    products: products, // no need to stringify, axios handles it
  };

  try {
    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_invoice_categories",
      payload,
      {
        headers: {
          "Content-Type": "application/json", // JSON content
        },
      }
    );

    console.log("API Response:", response.data);

    if (response.data.status === "true" || response.data.status === true) {
      toast.success(response.data.message || "Invoice Created Successfully");
    } else {
      toast.error(response.data.message || "Failed to create invoice");
    }
  } catch (error) {
    console.error("Error submitting invoice:", error);
    toast.error("Something went wrong!");
  }
};



  return (
  <div className="page-content">
  {/* Start Container Fluid */}
  <div className="container-fluid">
    {/* ========== Page Title Start ========== */}
    <div className="row">
      <div className="col-12">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Invoices Create</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="javascript: void(0);">Invoices</a>
            </li>
            <li className="breadcrumb-item active">Invoices Create</li>
          </ol>
        </div>
      </div>
    </div>
    {/* ========== Page Title End ========== */}
    <div className="row justify-content-center">
      <div className="col-lg-10">
        <div className="card">
          <div className="card-body">
            {/* Logo & title */}
            <form onSubmit={handleSubmit}>
            <div className="pb-3 mb-4 position-relative border-bottom">
              <div className="row justify-content-between">
                <div className="col-lg-5">
                  <div className="">
                    <div
                      className="w-50 auth-logo border border-primary bg-light-subtle p-2 rounded"
                      style={{ borderStyle: "dashed !important" }}
                    >
                      <div className="profile-photo-edit">
                        <input
                          id="profile-img-file-input"
                          type="file"
                          className="profile-img-file-input"
                        />
                        <label
                          htmlFor="profile-img-file-input"
                          className="profile-photo-edit avatar-xs"
                        >
                          <img
                            src="/images/logo-dark.png"
                            className="logo-dark me-1 user-profile-image"
                            alt="user-profile-image"
                            height={24}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="mt-5 pt-2">
                        <div className="mb-3">
                          <label
                            htmlFor="sender-name"
                            className="form-label text-dark"
                          >
                            Sender Name
                          </label>
                          <input
                          type="text"
                          id="customer_name"
                          className="form-control"
                          placeholder="Enter Name"
                          value={formData.customer_name}
                          onChange={handleChange}
                        />
                        </div>
                        <div className="mb-3">
                          <label
                            htmlFor="sender-address"
                            className="form-label text-dark"
                          >
                            Sender Full Address
                          </label>
                          <textarea
                            className="form-control"
                            id="sender_address" // ✅ matches the state key
                            value={formData.sender_address}
                            onChange={handleChange}
                          />

                        </div>
                      
                        <div className="mb-3">
                          <label
                            htmlFor="sender-number"
                            className="form-label text-dark"
                          >
                            Phone number
                          </label>
                          <input
                            type="text"
                            id="sender_number"
                            className="form-control"
                            placeholder="Number"
                            value={formData.sender_number}
                            onChange={handleChange}
                          />
                        </div>
                      
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  
                    <div className="mb-3">
                      <label
                        htmlFor="invoice-no"
                        className="form-label text-dark"
                      >
                        Invoice Number :
                      </label>
                      <input
                        type="text"
                        id="invoice_id"
                        className="form-control"
                        placeholder="#INV-****"
                        defaultValue="#INV-0758267/90"
                        value={formData.invoice_id}
                        onChange={handleChange}
                      />
                    </div>
                  
                  
                    <div className="mb-3">
                      <label
                        htmlFor="schedule-date"
                        className="form-label text-dark"
                      >
                        Issue Date :
                      </label>
                      <input
                        type="date"
                        id="issue_date"
                        className="form-control flatpickr-input active"
                        placeholder="dd-mm-yyyy"
                        value={formData.issue_date}
                        onChange={handleChange}
                      />
                    </div>
                  
                  
                    <div className="mb-3">
                      <label
                        htmlFor="due-date"
                        className="form-label text-dark"
                      >
                        Due Date :
                      </label>
                      <input
                        type="date"
                        id="due_date"
                        className="form-control flatpickr-input active"
                        placeholder="dd-mm-yyyy"
                        value={formData.due_date}
                        onChange={handleChange}
                      />
                    </div>
                  
                  
                    <label
                      htmlFor="product-price"
                      className="form-label text-dark"
                    >
                      Amount :
                    </label>
                    <div className="input-group mb-3">
                      <span className="input-group-text fs-20 bg-light text-dark">
                        <i className="bx bx-dollar" />
                      </span>
                      <input
                        type="number"
                        id="amount"
                        className="form-control"
                        placeholder="000"
                        value={formData.amount}
                        onChange={handleChange}                  
                      />
                    </div>
                  
                  
                    <label htmlFor="status" className="form-label text-dark">
                      Status :
                    </label>
                    <select
                      className="form-select"
                      id="status"
                      aria-label="Default select example"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option selected="">Paid</option>
                      <option value="Cancel">Cancel</option>
                      <option value="Pending">Pending</option>
                    </select>
                  
                </div>
              </div>
            </div>
            <div className="row justify-content-between">
              <div className="col-lg-5">
                <h4 className="mb-3">Issue From :</h4>
                
                  <div className="mb-2">
                    <input
                      type="text"
                      id="buyer_from"
                      className="form-control"
                      placeholder="First name"
                      value={formData.buyer_from}
                      onChange={handleChange}
                    />
                  </div>
                
                
                  <div className="mb-2">
                    <textarea
                      className="form-control"
                      id="buyer_address"
                      rows={3}
                      placeholder="Enter address"
                      defaultValue={""}
                      value={formData.buyer_address}
                      onChange={handleChange}
                    />
                  </div>
                
                
                  <div className="mb-2">
                    <input
                      type="number"
                      id="buyer_number"
                      className="form-control"
                      placeholder="Number"
                      value={formData.buyer_number}
                      onChange={handleChange}
                    />
                  </div>
                
                
                  <div className="mb-2">
                    <input
                      type="email"
                      id="buyer_email"
                      className="form-control"
                      placeholder="Email Address"
                      value={formData.buyer_email}
                      onChange={handleChange}
                    />
                  </div>
                
              </div>
              <div className="col-lg-5">
                <h4 className="mb-3">Issue For :</h4>
                
                  <div className="mb-2">
                    <input
                      type="text"
                      id="issuer_from"
                      className="form-control"
                      placeholder="First name"
                      value={formData.issuer_from}
                      onChange={handleChange}
                    />
                  </div>
                
                
                  <div className="mb-2">
                    <textarea
                      className="form-control"
                      id="issuer_address"
                      rows={3}
                      placeholder="Enter address"
                      defaultValue={""}
                      value={formData.issuer_address}
                      onChange={handleChange}
                    />
                  </div>
                
                
                  <div className="mb-2">
                    <input
                      type="number"
                      id="issuer_number"
                      className="form-control"
                      placeholder="Number"
                      value={formData.issuer_number}
                      onChange={handleChange}
                    />
                  </div>
                
                
                  <div className="mb-2">
                    <input
                      type="email"
                      id="issuer_email"
                      className="form-control"
                      placeholder="Email Address"
                      value={formData.issuer_email}
                      onChange={handleChange}
                    />
                  </div>
                
              </div>
            </div>
            <div className="row mt-4">
      <div className="col-12">
        <div className="table-responsive table-borderless text-nowrap table-centered">
          <table className="table mb-0">
            <thead className="bg-light bg-opacity-50">
              <tr>
                <th className="border-0 py-2">Product Name</th>
                <th className="border-0 py-2">Quantity</th>
                <th className="border-0 py-2">Price</th>
                <th className="border-0 py-2">Tax</th>
                <th className="border-0 py-2">Total</th>
              </tr>
            </thead>

            <tbody>
              {products.map((formData, index) => (
                <tr key={index}>
                  <td>
                    <div className="d-flex gap-3">
                      <div
                        className="auth-logo border-0 rounded"
                        style={{ borderStyle: "dashed !important" }}
                      >
                        <div className="profile-photo-edit">
                          <input
                            id={`profile-img-file-input-${index}`}
                            type="file"
                            className="profile-img-file-input1"
                          />
                          <label
                            htmlFor={`profile-img-file-input-${index}`}
                            className="profile-photo-edit avatar bg-light rounded"
                          >
                            <img
                              src=""
                              alt=""
                              className="me-1 user-profile-image1 img-fluid"
                            />
                          </label>
                        </div>
                      </div>

                      <div className="w-75">
                        <div className="mb-3">
                          <input
                            type="text"
                            id="product_name"
                            className="form-control"
                            placeholder="Product Name"
                            value={formData.product_name}
                            onChange={(e) => handleChangerow(index, e)}
                          />
                        </div>

                        <div className="mb-3">
                          <input
                            type="text"
                            id="product_size"
                            className="form-control"
                            placeholder="Product Size"
                            value={formData.product_size}
                            onChange={(e) => handleChangerow(index, e)}
                          />
                        </div>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div className="quantity">
                      <div className="input-step border bg-body-secondary p-1 rounded d-inline-flex overflow-visible">
                        <button
                          type="button"
                          className="minus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                          onClick={() => {
                            const updated = [...products];
                            if (updated[index].product_qty > 1)
                              updated[index].product_qty--;
                            setProducts(updated);
                          }}
                        >
                          -
                        </button>
                        <input
                          type="number"
                          className="text-dark text-center border-0 bg-body-secondary rounded h-100"
                          min={0}
                          max={100}
                          id="product_qty"
                          value={formData.product_qty}
                          onChange={(e) => handleChangerow(index, e)}
                        />
                        <button
                          type="button"
                          className="plus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                          onClick={() => {
                            const updated = [...products];
                            updated[index].product_qty++;
                            setProducts(updated);
                          }}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div className="input-group">
                      <span className="input-group-text fs-20 bg-light text-dark">
                        <i className="bx bx-dollar" />
                      </span>
                      <input
                        type="number"
                        id="product_price"
                        className="form-control"
                        placeholder="000"
                        value={formData.product_price}
                        onChange={(e) => handleChangerow(index, e)}
                      />
                    </div>
                  </td>

                  <td>
                    <div className="input-group">
                      <span className="input-group-text fs-20 bg-light text-dark">
                        <i className="bx bx-dollar" />
                      </span>
                      <input
                        type="number"
                        id="product_tax"
                        className="form-control"
                        placeholder="000"
                        value={formData.product_tax}
                        onChange={(e) => handleChangerow(index, e)}
                      />
                    </div>
                  </td>

                  <td>
                    <div className="input-group">
                      <span className="input-group-text fs-20 bg-light text-dark">
                        <i className="bx bx-dollar" />
                      </span>
                      <input
                        type="number"
                        id="total"
                        className="form-control"
                        placeholder="000"
                        value={formData.total}
                        onChange={(e) => handleChangerow(index, e)}
                      />
                    </div>
                  </td>

                  {/* Clear Product Button per row */}
                  <td>
                    <button
                      type="button"
                      onClick={() => handleClearRow(index)}
                      className="btn btn-danger btn-sm"
                    >
                      Clear Product
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Add More Button (keeps same design) */}
        <div className="text-end border-top">
          <div className="pt-3">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handleAddRow}
            >
              Add More
            </button>
          </div>
        </div>
      </div>
    </div>
            <div className="row justify-content-end">
              <div className="col-lg-4">
                <label htmlFor="sub-total" className="form-label text-dark">
                  Sub Total :
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text fs-20 bg-light text-dark">
                    <i className="bx bx-dollar" />
                  </span>
                  <input
                    type="number"
                    id="sub_total"
                    className="form-control"
                    placeholder="000"
                    value={formData.sub_total}
                    onChange={handleChange}
                    />
                </div>
                <label
                  htmlFor="discount-price"
                  className="form-label text-dark"
                >
                  Discount :
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text fs-20 bg-light text-dark">
                    <i className="bx bx-dollar" />
                  </span>
                  <input
                    type="number"
                    id="discount"
                    className="form-control"
                    placeholder="000"
                    value={formData.discount}
                    onChange={handleChange}
                    />
                </div>
                <label
                  htmlFor="discount-price"
                  className="form-label text-dark"
                >
                  Estimated Tax (15.5%) :
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text fs-20 bg-light text-dark">
                    <i className="bx bx-dollar" />
                  </span>
                  <input
                    type="number"
                    id="estimated_tax"
                    className="form-control"
                    placeholder="000"
                    value={formData.estimated_tax}
                    onChange={handleChange}
                    />
                </div>
                <div className="border-top">
                  <label
                    htmlFor="grand-total"
                    className="form-label text-dark pt-3"
                  >
                    Grand Amount :
                  </label>
                  <div className="input-group mb-3">
                    <span className="input-group-text fs-20 bg-light text-dark">
                      <i className="bx bx-dollar" />
                    </span>
                    <input
                      type="number"
                      id="grand_total"
                      className="form-control"
                      placeholder="000"
                      value={formData.grand_total}
                      onChange={handleChange}
                      />
                  </div>
                </div>
              </div>
            </div>
            <div style={{textAlign:"end"}}>
              <button type="submit" className="btn btn-primary">
                    Submit Invoice
                  </button>
            </div>
            <div className="row mt-3">
              <div className="col-lg-12">
                <div className="alert alert-danger alert-icon p-2" role="alert">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm rounded bg-danger d-flex justify-content-center align-items-center fs-18 me-2 flex-shrink-0">
                      <i className="bx bx-info-circle text-white" />
                    </div>
                    <div className="flex-grow-1">
                      All accounts are to be paid within 7 days from receipt of
                      invoice. To be paid by cheque or credit card or direct
                      payment online. If account is not paid within 7 days the
                      credits details supplied as confirmation of work
                      undertaken will be charged the agreed quoted fee noted
                      above.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* End Container Fluid */}
  {/* ========== Footer Start ========== */}
  <footer className="footer">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 text-center">
          © Venton. Crafted by{" "}
          <iconify-icon
            icon="iconamoon:heart-duotone"
            className="fs-18 align-middle text-danger"
          />{" "}
          <a href="" className="fw-bold footer-text" target="_blank">
            Techzaa
          </a>
        </div>
      </div>
    </div>
  </footer>
  {/* ========== Footer End ========== */}
</div>

  )
}

export default InvoiceCreate
